import axios from "axios";
import { getAuthHeader } from '../utils';

export const SubscribedJobPackageList = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-job-package-list`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const savePaymentDetail = (model) => {
    debugger
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-save-payment-details`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
};


export const SubscribedPackageList = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/emp-package-subscription-list`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};
export const SubscribeInvoice = (PKG_SUBSC_ID) => {
    const url = `${process.env.REACT_APP_BASE_URL}/emp-subscription-invoice?PKG_SUBSC_ID=${PKG_SUBSC_ID}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const getTransancionDetails = (txn_id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-get-transaction-details?SUBSCRIPTION_TXN_ID=${txn_id}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};

